
/* styles */
require("!!vue-style-loader!css-loader?sourceMap!./../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-48870b8b&scoped=true!stylus-loader!./../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./RegisterAgreement.vue")

var Component = require("!./../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./RegisterAgreement.vue"),
  /* template */
  require("!!./../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-48870b8b!./../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./RegisterAgreement.vue"),
  /* scopeId */
  "data-v-48870b8b",
  /* cssModules */
  null
)
Component.options.__file = "/app/src/components/Login/common/RegisterAgreement.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] RegisterAgreement.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-48870b8b", Component.options)
  } else {
    hotAPI.reload("data-v-48870b8b", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Login/common/RegisterAgreement.vue
// module id = 770
// module chunks = 0